module.exports = __webpack_public_path__ + "img/ceccd4398039c98ceee5f9db4d5eef49.png";